// extracted by mini-css-extract-plugin
export default {"rowDragging":"styles_rowDragging__iNLP7","dragVisible":"styles_dragVisible__9EfBq","menuIcon":"styles_menuIcon__71+-F","tableWrapper":"styles_tableWrapper__Sh11+"};